import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import links from "./links";
import { map } from "lodash";

export default function Naviga() {
  return (
    <Router>
      <Switch>
        {map(links, (route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <route.layout>
                <route.component {...props} />
              </route.layout>
            )}
          />
        ))}
      </Switch>
    </Router>
  );
}